<template>
	<screen class="login-view" type="blue">
		<template slot="header">
			<ui-header type="light" @click="onDismiss" action="close">
				<h2 slot="title">Login</h2>
			</ui-header>
		</template>
		<form v-on:submit.prevent="onSubmit">
			<label>
				<ui-input type="blue" placeholder="Email" v-model="email" />
			</label>
			<label>
				<ui-input
					type="blue"
					placeholder="Password"
					native-type="password"
					v-model="password"
				/>
			</label>
			<label>
				<ui-button
					native-type="submit"
					color="white"
					:loading="isLoading"
					>Login</ui-button
				>
			</label>
		</form>
		<router-link
			class="forgot-password mt-3"
			:to="{ name: 'forgot-password', params: {} }"
			>Forgot Password?</router-link
		>
		<router-link
			class="sign-up mt-3"
			:to="{
				name: 'register',
				params: {}
			}"
			>Don't have an account? Sign up!</router-link
		>
	</screen>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import UiButton from '../../ui/Button'
import UiInput from '../../ui/Input'
import UiHeader from '../../ui/Header'
import Screen from '../../ui/Screen'

export default {
	name: 'login-view',
	components: { UiButton, UiInput, UiHeader, Screen },
	props: ['redirect'],
	data() {
		return {
			isLoading: false,
			email: '',
			password: ''
		}
	},
	methods: {
		...mapGetters(['hasTOS']),
		...mapActions(['login']),
		onSubmit() {
			this.isLoading = true
			this.login({ email: this.email, password: this.password })
				.then(() => {
					this.isLoading = false
					if (this.redirect) {
						this.$router.push({ name: this.redirect.toLowerCase() })
					} else {
						this.$router.push({ name: 'home' })
					}
				})
				.catch(({ message }) => {
					this.isLoading = false
					this.$swal('Error', message)
				})
		},
		onDismiss() {
			this.navigate({ name: 'launch' }, 'fade')
		}
	},
	mounted() {
		if (this.redirect === 'logout') {
			this.navigate({ name: 'login' })
		}
	}
}
</script>

<style lang="scss">
.login-view {
	@media screen and (max-width: 480px) {
		padding-top: 60px;
	}
	.forgot-password,
	.sign-up {
		color: $white;
		opacity: 0.7;
		transition: all 0.25s ease-in-out;
		text-align: center;
		display: block;
		text-decoration: none !important;
		&:hover {
			opacity: 1;
		}
	}
}
</style>
}
